import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useRef } from 'react';
import { Modal, TouchableOpacity, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { WindowInformation } from '../../../services/window-information';

interface Props {
    videoUrl: string;
    isModalVisible: boolean;
    setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function VideoModal({ videoUrl, isModalVisible, setIsModalVisible }: Props) {
    const { styles, theme } = useStyles(styleSheet);
    const windowInfo = WindowInformation();

    const videoRef = useRef<HTMLVideoElement>(null);

    return <Modal
        animationType='fade'
        transparent={true}
        visible={isModalVisible}
        onRequestClose={() => setIsModalVisible(false)}>
        <View style={[styles.modalContainer]}>
            <View style={styles.centeredView}>
                <View style={styles.modalBody}>
                    <View style={{ alignItems: 'flex-end' }}>
                        <TouchableOpacity
                            style={{ width: 40, height: 40 }}
                            onPress={() => setIsModalVisible(false)}
                        >
                            <FontAwesomeIcon icon={faTimes} fontSize={40} color={theme.colors.iconColor} />
                        </TouchableOpacity>
                    </View>
                    <View style={styles.imageContainer}>
                        <video ref={videoRef} width={windowInfo.width - 70} height={windowInfo.height - 100} controls>
                            <source src={videoUrl} type='video/mp4' />
                        </video>
                    </View>
                </View>
            </View>
        </View>
    </Modal>;
}

const styleSheet = createStyleSheet((theme) => ({
    modalContainer: {
        flex: 1,
        backgroundColor: '#31313199'
    },
    centeredView: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    modalBody: {
        backgroundColor: theme.colors.container.background,
        flexDirection: 'column',
        justifyContent: 'center',
        borderRadius: 8,
        flex: 1,
        padding: 10,
        width: '95%',
        maxHeight: '70%'
    },
    imageContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
    }
}));
